export default {
  submit: {
    id: 'checkout_billing_address_form_submit',
    defaultMessage: 'Next',
  },
  userInformationTitle: {
    id: 'checkout_billing_user_information_title',
    defaultMessage: 'Personal information',
  },
  billingAddressTitle: {
    id: 'checkout_billing_page_information_title',
    defaultMessage: 'Billing Address',
  },
}
